import { InjectionToken } from '@angular/core';
import { Satellite } from '@cigna/core/interfaces';

export const SATELLITE = new InjectionToken<Satellite>('_satellite');

// eslint-disable-next-line no-var
export declare var _satellite: Satellite;

export function satelliteFactory(): Satellite {
  if (typeof _satellite !== 'undefined') {
    return _satellite;
  }

  // eslint-disable-next-line no-console
  console.warn(
    '_satellite not detected, analytics events will be added to queue and loaded later if library appears',
  );
}
